var path = '/opt/atlassian/pipelines/agent/build/src/app/common/components/pagination/pagination.html';
var html = "<nav aria-label=\"Page navigation\" class=pagination-content> <ul uib-pagination total-items=$ctrl.totalItems items-per-page=$ctrl.itemPerPage ng-change=$ctrl._onChange() ng-model=$ctrl.currentPage max-size=$ctrl.maxSize class=pagination-sm previous-text=\" \" next-text=\" \" boundary-link-numbers=true ng-if=\"$ctrl.totalItems > $ctrl.itemPerPage\"></ul> </nav> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/pagination/pagination.html
// module id = 923
// module chunks = 0